import {
  IRoadshowsCollectionFilters,
  IRoadshowsFilters,
  IRoadshowsPayload,
} from '@/creditflowresearch/application/Roadshows/vo/IRoadshowsPayload';
import { initRoadshowsFilters } from '@/creditflowresearch/application/Roadshows/constants';
import { IRoadshowsTileView } from '@/creditflowresearch/application/Roadshows/vo/IRoadshowsTileView';
import { IRoadshowResponse } from '@/creditflowresearch/application/Roadshows/vo/IRoadshowsResponse';

const getRoadshowsPayload = (
  filters: Partial<IRoadshowsFilters>,
  collectionFilters: IRoadshowsCollectionFilters,
): IRoadshowsPayload => ({
  filters: {
    ...initRoadshowsFilters,
    ...filters,
  },
  search: collectionFilters.search,
  sorting: {
    sortBy: collectionFilters.sortBy,
    sortOrder: collectionFilters.sortOrder,
  },
  paging: {
    page: collectionFilters.page,
    perPage: collectionFilters.perPage,
  },
});

const getRoadshowsTileViewData = (
  data: IRoadshowResponse[],
  email: string,
): IRoadshowsTileView[] => data.map(({ entryCode, deal }) => ({
  dealName: deal.name,
  dealUrl: deal.url,
  entryCode: entryCode.code,
  email,
}));

export {
  getRoadshowsPayload,
  getRoadshowsTileViewData,
};
